const formatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0
});

export const formatCurrency = (number) => formatter.format(number);

/** we need to select the active price first, as we have 3 different prices */
export const getPrices = (input) => {
    let cPrice = -1;

    if (input.prices.rentPrice !== null) {
        cPrice = input.prices.rentPrice;
    } else if (input.prices.definitive !== null) {
        cPrice = input.prices.definitive;
    } else if (input.prices.indicative !== null) {
        cPrice = input.prices.indicative;
    } else if (input.prices.indicativeMax !== null) {
        cPrice = input.prices.indicativeMax;
    }

    return cPrice;
};
